<template>
  <div>
    <span class="primary-text">{{ label }}</span>
    <v-menu
      ref="menu"
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="time"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="time"
          @input.native="$emit('input', $event.target.value)"
          prepend-icon="mdi-clock-time-four-outline"
          readonly
          v-bind="attrs"
          v-on="on"
          :outlined="outlined"
          :flat="flat"
          :dense="dense"
          :solo="solo"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu2"
        :value="time"
        @input.native="$emit('input', $event.target.value)"
        full-width
        format="24hr"
        @click:minute="$refs.menu.save(time)"
      ></v-time-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "TimePicker",
  props: ["label", "outlined", "flat", "solo", "dense"],
  data() {
    return {
      time: "00:00",
      menu2: false,
    };
  },
};
</script>